import { StateCreator } from "zustand";
import { StoreState } from "../useBoundStore";

export const navigationId = [
  "map",
  "fleets",
  "equipment-management",
  "tracking-devices",
  "ais-vessels",
  "dams",
  "ferries",
  "aton-units",
  "traffic-buoys",
  "test",
  "users",
  "organization",
  "api-keys",
  "map-areas",
  "ports",
  "events",
  "marine-survey-and-design",
  "file-explorer",
  "projects",
  "fairway-maintenance-reporting",
  "profile",
  "site",
  "Notifications",
] as const;

export type NavigationIdType = typeof navigationId[number];

type AlarmContent = {
  message: string;
};

export interface AlarmSliceState {
  alarmIndicatorObject: Partial<Record<NavigationIdType, AlarmContent>>;
  // setAlarmIndicator: (alarmKey: NavigationIdType) => void;
  //   removeAlarmIndicator: (alarmKey: NavigationIdType) => void;
  updateAlarm: (
    alarmKey: NavigationIdType,
    removeAlarm: boolean,
    message: string,
  ) => void;
}

export const createAlarmIndicatorSlice: StateCreator<
  StoreState,
  [],
  [],
  AlarmSliceState
> = (set) => ({
  alarmIndicatorObject: {},
  updateAlarm: (alarmKey, removeAlarm, message) =>
    set((state) => {
      let alarms = state.alarmIndicatorObject;
      if (
        (!alarms[alarmKey] && removeAlarm) ||
        (alarms[alarmKey] && !removeAlarm)
      )
        return {
          alarmIndicatorObject: alarms,
        };

      if (removeAlarm) {
        const copy = { ...alarms };
        delete copy[alarmKey];
        alarms = copy;

        delete alarms[alarmKey];
      } else alarms = { ...alarms, [alarmKey]: { message } };

      return {
        alarmIndicatorObject: alarms,
      };
    }),
});
